<template>
  <router-view />
</template>

<script>
export default {
  name: "App",

  components: {
    //
  },

  data: () => ({
    //
  })
};
</script>

<style lang="stylus">
::-webkit-scrollbar {
  width: 0.5rem;
  border:none
}

::-webkit-scrollbar-track {
  background: rgba(127,127,127,0.25);
  border:none
}

::-webkit-scrollbar-thumb {
  background: rgba(127,127,127,0.5);
  border:none
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(127,127,127,0.6);
  border:none
}
</style>
